import { render, staticRenderFns } from "./cartItemRow.vue?vue&type=template&id=b0834bf2&"
import script from "./cartItemRow.vue?vue&type=script&lang=js&"
export * from "./cartItemRow.vue?vue&type=script&lang=js&"
import style0 from "./cartItemRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports